import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { FormDropdown, FormShimmer, getById, mapToDropdownOption } from "sprint-common-web";

import { handleOptionChange } from "../../../../common/utils/handleOptionChange";
import { useResolutionOptions } from "../common/hooks/useResolutionOptions";
import { useCreateOrder } from "../common/provider/useCreateOrder";

interface OrderTargetResolutionSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
}

export const OrderTargetResolutionSelector = ({
    label,
    name,
    control,
    errors
}: OrderTargetResolutionSelectorProps): JSX.Element => {
    const { isLoading: areResolutionOptionsLoading, resolutions } = useResolutionOptions();
    const { setTargetResolution } = useCreateOrder();

    const handleEncodeSpecificationSelected = (value: string) => {
        const selectedEncodeSpecification = getById(resolutions, value);

        setTargetResolution(selectedEncodeSpecification);
    };

    const handleEncodeSpecificationUnselected = () => {
        setTargetResolution(undefined);
    };

    return (
        <FormShimmer isLoading={areResolutionOptionsLoading}>
            <FormDropdown
                label={label}
                placeholder="Select target resolution"
                name={name}
                options={resolutions.map((item) => mapToDropdownOption(item))}
                disabled={!resolutions.length}
                control={control}
                errors={errors}
                onChange={handleOptionChange(handleEncodeSpecificationSelected, handleEncodeSpecificationUnselected)}
            />
        </FormShimmer>
    );
};
